import React, { useState, useEffect } from "react";
import { Cpu, Check, Loader2 } from "lucide-react";

const ProcessingModal = ({ type = "text" }) => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setStep((s) => (s < 4 ? s + 1 : s)), 1500);
    return () => clearInterval(interval);
  }, []);

  const getSteps = () => {
    if (type === "image") return ["🔍 正在掃描題目圖片...", "🧠 識別數理模型與公式...", "✍️ 正在推導解題步驟...", "🚀 整理最終答案中..."];
    if (type === "quiz") return ["💡 正在分析核心觀念...", "🎯 構思類似題型...", "✍️ 編寫題目與詳解...", "🚀 舉一反三生成中..."];
    if (type === "concept") return ["✨ 正在分析解題過程...", "🧠 歸納核心重點...", "📝 整理詳細觀念說明...", "🚀 重點整理生成中..."];
    return ["📖 正在閱讀題目文字...", "🧠 識別數理模型...", "✍️ 正在推導解題步驟...", "🚀 整理最終答案中..."];
  };

  const steps = getSteps();

  return (
    <div className="fixed inset-0 z-[9999] flex justify-center bg-black/80 backdrop-blur-md animate-in fade-in duration-300">
      <div className="fixed top-[15vh] md:top-[20vh] bg-white rounded-[2rem] shadow-2xl w-full max-w-sm overflow-hidden p-8 border border-orange-100 fade-in animate-in slide-in-from-top-4 duration-500">
        <div className="flex flex-col items-center mb-6">
          <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center relative mb-4">
            <div className="absolute inset-0 rounded-full border-4 border-orange-200 animate-[pulse-ring_1.5s_infinite]" />
            <Cpu size={32} className="text-orange-500 animate-pulse" />
          </div>
          <h3 className="text-xl font-black text-slate-800 tracking-tight">AI 深度思考中</h3>
        </div>
        <div className="space-y-4">
          {steps.map((text, i) => (
            <div key={i} className={`flex items-center gap-3 transition-all duration-500 ${step >= i ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-4"}`}>
              <div className={`w-6 h-6 rounded-full flex items-center justify-center border-2 ${step > i ? "bg-green-500 border-green-500 text-white" : step === i ? "border-orange-500 text-orange-500" : "border-slate-200"}`}>
                {step > i ? <Check size={14} strokeWidth={4} /> : step === i ? <Loader2 size={14} className="animate-spin" /> : <div className="w-1.5 h-1.5 rounded-full bg-slate-200" />}
              </div>
              <span className={`text-sm font-bold ${step === i ? "text-slate-800" : "text-slate-400"}`}>{text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProcessingModal;
